<template>
  <div class="home_detail">
    <LayoutTopComponent></LayoutTopComponent>

    <HC3620Component v-show="isHC3620Show"></HC3620Component>
    <CC3623Component v-show="isCC3623"></CC3623Component>
    <BLHSG03Component v-show="isBLHSG03Show"></BLHSG03Component>
    <TF3661Component v-show="isTF3661Show"></TF3661Component>
    <BLZNC03Component v-show="isBLZNC03Show"></BLZNC03Component>
    <BL3FL02Component v-show="isBL3FL02Show"></BL3FL02Component>
    <BLPJS01Component v-show="isBLPJS01Show"></BLPJS01Component>
    <BL2FL01Component v-show="isBL2FL01Show"></BL2FL01Component>
    <BLSHJ02Component v-show="isBLSHJ02Show"></BLSHJ02Component>
    <BLFGC01Component v-show="isBLFGC01Show"></BLFGC01Component>
    <FK4151Component v-show="isFK4151Show"></FK4151Component>
    <VTCWM101Component v-show="isVTCWM101Show"></VTCWM101Component>
    <VTYHV1Component v-show="isVTYHV1Show"></VTYHV1Component>
    <CJ9100Component v-show="isCJ9100Show"></CJ9100Component>
    <KG4002Component v-show="isKG4002Show"></KG4002Component>
    <BP4202Component v-show="isBP4202Show"></BP4202Component>
    <ZJ4362Component v-show="isZJ4362Show"></ZJ4362Component>
    <ZJ4361Component v-show="isZJ4361Show"></ZJ4361Component>
    <TZ3670Component v-show="isTZ3670Show"></TZ3670Component>

    <LayoutBottomComponent></LayoutBottomComponent>

  </div>

</template>

<script>

import TZ3670Component from "../components/TZ3670Component";
import LayoutTopComponent from "../components/LayoutTopComponent";
import LayoutBottomComponent from "../components/LayoutBottomComponent";
import HC3620Component from "../components/HC3620Component";
import CC3623Component from "../components/CC3623Component";
import BLHSG03Component from "@/components/BLHSG03Component";
import TF3661Component from "../components/TF3661Component";
import BLZNC03Component from "../components/BLZNC03Component";
import BL3FL02Component from "@/components/BL3FL02Component";
import BLPJS01Component from "@/components/BLPJS01Component";
import BL2FL01Component from "../components/BL2FL01Component";
import BLSHJ02Component from "@/components/BLSHJ02Component";
import BLFGC01Component from "@/components/BLFGC01Component";
import FK4151Component from "@/components/second/FK4151Component";
import VTCWM101Component from "@/components/second/VTCWM101Component";
import VTYHV1Component from "@/components/second/VTYHV1Component";
import CJ9100Component from "@/components/second/CJ9100Component";
import KG4002Component from "@/components/second/KG4002Component";
import BP4202Component from "@/components/second/BP4202Component";
import ZJ4362Component from "@/components/second/ZJ4362Component";
import ZJ4361Component from "@/components/second/ZJ4361Component";

export default {
  data() {
    return {
      isHC3620Show: false,
      isCC3623: false,
      isBLHSG03Show: false,
      isTF3661Show: false,
      isBLZNC03Show: false,
      isBL3FL02Show: false,
      isBLPJS01Show: false,
      isBL2FL01Show: false,
      isBLSHJ02Show: false,
      isBLFGC01Show: false,
      isFK4151Show: false,
      isVTCWM101Show: false,
      isVTYHV1Show: false,
      isCJ9100Show: false,
      isKG4002Show: false,
      isBP4202Show: false,
      isZJ4362Show: false,
      isZJ4361Show: false,
      isTZ3670Show: false,
    }
  },
  components: {
    TZ3670Component,
    ZJ4361Component,
    ZJ4362Component,
    BP4202Component,
    KG4002Component,
    CJ9100Component,
    VTYHV1Component,
    VTCWM101Component,
    FK4151Component,
    BLFGC01Component,
    BLSHJ02Component,
    BLHSG03Component,
    BLPJS01Component,
    BL3FL02Component,
    LayoutTopComponent,
    LayoutBottomComponent,
    HC3620Component,
    CC3623Component,
    BL2FL01Component,
    TF3661Component,
    BLZNC03Component,
  },
  mounted() {
    const option = this.$route.query;
    if (option) {
      console.log(option)
      switch (option.type) {
        case "HC3620": // 回收称
          this.isHC3620Show = true;
          break
        case "CC3623": // 厨房秤
          this.isCC3623 = true;
          break
        case "BLHSG03": // 厨房秤
          this.isBLHSG03Show = true;
          break
        case "TF3661": // 厨房秤
          this.isTF3661Show = true;
          break
        case "BLZNC03": // 厨房秤
          this.isBLZNC03Show = true;
          break
        case "BL3FL02": // 厨房秤
          this.isBL3FL02Show = true;
          break
        case "BLPJS01": // 厨房秤
          this.isBLPJS01Show = true;
          break
        case "BL2FL01": // 厨房秤
          this.isBL2FL01Show = true;
          break
        case "BLSHJ02": // 厨房秤
          this.isBLSHJ02Show = true;
          break
        case "BLFGC01": // 厨房秤
          this.isBLFGC01Show = true;
          break
          //  访客机
        case "FK4151":
          this.isFK4151Show = true;
          break
        case "VTCWM101":
          this.isVTCWM101Show = true;
          break
        case "VTYHV1":
          this.isVTYHV1Show = true;
          break
        case "CJ9100":
          this.isCJ9100Show = true;
          break
        case "KG4002":
          this.isKG4002Show = true;
          break
        case "BP4202":
          this.isBP4202Show = true;
          break
        case "ZJ4362":
          this.isZJ4362Show = true;
          break
        case "ZJ4361":
          this.isZJ4361Show = true;
          break
        case "TZ3670":
          this.isTZ3670Show = true;
          break
      }
    }
  },
}
</script>

<style lang="less" scoped>

@import "../assets/css/common";

@media screen and (max-width: 1280px) {
  .home_detail {
    width: @screenWidth1280;
    margin-top: @layoutTopHight1280;
  }
}

@media screen and (min-width: 1281px) and (max-width: 1440px) {

  .home_detail {
    width: @screenWidth1440;
    margin-top: @layoutTopHight1440;
  }

}

@media screen and (min-width: 1441px) and (max-width: 1920px) {
  .home_detail {
    width: @screenWidth1920;
    margin-top: @layoutTopHight1920;
  }
}

.home_detail {
  display: flex;
  flex-direction: column;
}

</style>